import { render, staticRenderFns } from "./staticHeader.vue?vue&type=template&id=c126e96c&scoped=true&"
import script from "./staticHeader.vue?vue&type=script&lang=js&"
export * from "./staticHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c126e96c",
  null
  
)

export default component.exports